import React, { useEffect, useState } from 'react';

import './index.css';

interface Props {
    toggled: boolean,
    onChange?: Function,
    title?: string,
    name?: string
}

const LcToggle: React.FC<Props> = (props) => {

    const handleCheck = () => {
        props.onChange &&
            props.onChange({ name: props.name, checked: !props.toggled });
    }

    return (
        <div className={`input-toggle ${props.toggled ? 'toggled' : ''}`} onClick={handleCheck}>
            <div className="box">
                <div className="dot" />
            </div>
            {
                props.title && <span className="title"> {props.title} </span>
            }
        </div>
    );
}

export default LcToggle;